export const ENDPOINT = "https://nihareeka-api.onrender.com";
